import type { FileAddedActivityDetails } from '@paintscout/api'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import ActivityOwner from '../ActivityOwner'
import Highlight from '../../Highlight'
import React from 'react'

export default function FileAddedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props

  return (
    <>
      <ActivityTitle>
        <>
          {((activity.details as FileAddedActivityDetails)?.fileCount ?? 0) > 1 ? (
            <>
              <Highlight>Files</Highlight> were
            </>
          ) : (
            <>
              <Highlight>File</Highlight> was
            </>
          )}{' '}
          <Highlight>added</Highlight> <ActivityOwner activity={activity} />
        </>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
